import React, { useState } from "react";
import { adminLogin } from "../api/adminApi";

const AdminLoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(""); // clear previous

    if (!email || !password) {
      setMessage("Please enter email and password.");
      return;
    }

    const data = { email, password };

    const res = await adminLogin(data);

    if (res.success) {
      localStorage.setItem("adminToken", res.data.token);
      localStorage.setItem("role", "admin");
      setMessage("Login successful! Redirecting...");

      setTimeout(() => {
        window.location.href = "/registered-members";
      }, 1000);
    } else {
      setMessage(res.message || "Login failed!");
    }
  };

  return (
    <section className="min-h-screen flex items-center justify-center bg-gradient-to-br from-white via-[#fffaf4] to-[#fff1dc]">
      <div className="w-full max-w-md bg-white rounded-3xl shadow-xl p-8 mt-24 md:mt-32">
        <h2 className="text-3xl font-extrabold text-primary mb-6 text-center">
          Admin <span className="text-accent">Login</span>
        </h2>

        {message && (
          <p className="text-center text-gray-700 mb-4">{message}</p>
        )}

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-sm font-semibold text-primary mb-2">
              Email
            </label>
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-accent/30 rounded-xl px-4 py-3 focus:ring-2 focus:ring-accent/50 outline-none"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-semibold text-primary mb-2">
              Password
            </label>
            <input
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-accent/30 rounded-xl px-4 py-3 focus:ring-2 focus:ring-accent/50 outline-none"
              required
            />
          </div>

          <div className="flex justify-center">
            <button
              type="submit"
              className="w-full px-6 py-3 bg-gradient-to-r from-accent to-amber-400 text-white font-semibold rounded-full shadow-lg hover:scale-105 transition-transform duration-300"
            >
              Login
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default AdminLoginPage;
